import React from 'react';

export enum SpinnerColor {
  Blue,
  White,
  Red,
}
interface SpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
  height: string;
  width: string;
  containerClassName?: string;
  spinnerColor?: SpinnerColor;
}

export const Spinner = ({
  height,
  width,
  containerClassName,
  spinnerColor,
  ...rest
}: SpinnerProps) => {
  const getSpinnerColor = () => {
    switch (spinnerColor) {
      case SpinnerColor.Blue:
        return 'border-outline-brand-primary';
      case SpinnerColor.White:
        return 'border-outline-primary-bw-00';
      case SpinnerColor.Red:
        return 'border-outline-negative-primary';

      default:
        return 'border-outline-primary-bw-00';
    }
  };
  return (
    <div
      data-testid='spinner'
      className={`w-full !pl-0 h-full flex justify-center items-center relative ${containerClassName}`}
      {...rest}>
      <div
        className={`border-b-2 rounded-full animate-spin ${getSpinnerColor()}`}
        style={{
          width,
          height,
        }}
      />
    </div>
  );
};
